/**
 * Görev değişikliği bildirimi: görev kapatılınca, ertelenince, aktarılınca ya da not
 * açılıp silinince üst çubuktaki sayaç ve açık görev listeleri yeniden çekilsin diye.
 * Ekranlar ayrı ağaçlarda (sayaç üst çubukta, işlem sayfada); ortak durum yerine
 * dinleyici listesi yeter.
 */
type Dinleyici = () => void;

const dinleyiciler = new Set<Dinleyici>();

/** Dinlemeyi bırakan işlevi döndürür (etkinin temizliği için). */
export const gorevDegisikliginiDinle = (dinleyici: Dinleyici): (() => void) => {
  dinleyiciler.add(dinleyici);
  return () => {
    dinleyiciler.delete(dinleyici);
  };
};

export const gorevlerDegisti = (): void => {
  dinleyiciler.forEach((dinleyici) => dinleyici());
};
